export const SET_NAME_CLIENT = 'SET_NAME_CLIENT'
